import { render, staticRenderFns } from "./MeasurementsTomaia.vue?vue&type=template&id=fcad74aa&scoped=true&"
import script from "./MeasurementsTomaia.vue?vue&type=script&lang=js&"
export * from "./MeasurementsTomaia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcad74aa",
  null
  
)

export default component.exports